"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const button_1 = require("../button");
const copy_button_styles_1 = require("./copy-button.styles");
require("./copy-button.types");
const CopyIcon = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/copy'))));
exports.CopyButton = (0, react_1.memo)(({ label, textToCopy, successText, className }) => {
    const theme = (0, theme_1.useTheme)();
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(false);
    const handleClick = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (isSuccess)
            return;
        yield navigator.clipboard.writeText(textToCopy);
        setIsSuccess(true);
        const timeout = setTimeout(() => {
            setIsSuccess(false);
            clearTimeout(timeout);
        }, 1000);
    }), [textToCopy, isSuccess]);
    const buttonText = isSuccess ? successText : label;
    return (react_1.default.createElement(copy_button_styles_1.Wrapper, { className: className },
        react_1.default.createElement(button_1.Button, { variant: "text", label: buttonText, onClick: handleClick }),
        react_1.default.createElement(react_1.Suspense, { fallback: "" },
            react_1.default.createElement(CopyIcon, { width: 20, color: theme.colors.text.interactive }))));
});
